import {get, apiRoutes} from './../../api/api';

export const REQUEST_TAGS = 'REQUEST_TAGS';
export const RECEIVE_TAGS = 'RECEIVE_TAGS';

export function fetchTags(language) {
  return dispatch => {
    dispatch(requestTags());
    const url = apiRoutes.tags.getAll(language);
    return get(url, function (response) {
      dispatch(receiveTags(response.data));
    });
  };
}

function requestTags() {
  return {
    type: REQUEST_TAGS
  };
}

function receiveTags(data) {
  return {
    type: RECEIVE_TAGS,
    items: data,
    receivedAt: Date.now()
  };
}



/** WEBPACK FOOTER **
 ** ./src/modules/tags/actions.js
 **/